export const baseUrl = "https://api.utirx.com";
// export const baseUrl = "https://staging-api.utirx.com";
